import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star, StarBorder } from "@mui/icons-material";
import { getOrderDetails,getGeofenceByFleetId, getFleetConfigByFleetId, getFeedback } from "../API";
import {findNorthWestAndSouthEast} from "../utils"

import Header from "./Header";
import Footer from "./Footer";
import CustomerFeedback from "./CustomerFeedback";
import PinVerificationModal from "./reusable/PinVerificationModal";
function OrderDelivered() {
  const { orderID } = useParams();
  const [orderDetails, setOrderDetails] = useState();
  const [hasFeedback, setHasFeedback] = useState(false);
  const [isCheckingFeedback, setIsCheckingFeedback] = useState(true);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [submittedFeedback, setSubmittedFeedback] = useState(null);
  const [expectedPin, setExpectedPin] = useState(null);
  const [pinVerified, setPinVerified] = useState(false);

  const loaderContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "10vh",
  };

  const loaderStyle = {
    border: "4px solid rgba(0, 0, 0, 0.1)",
    borderTop: "4px solid 000",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    animation: "spin 1s linear infinite",
  };

  const keyframesAnimation = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  useEffect(() => {
    getOrderDetails(orderID)
      .then((res) => {
        const data = res?.data?.data;
        const pinVal = data?.pin;
        if (pinVal != null && String(pinVal).trim() !== "") {
          setExpectedPin(String(pinVal).trim());
        }
        getGeofenceByFleetId(data?.fleetId).then((res)=>{
          const maxBoundCordinates = findNorthWestAndSouthEast(res.data.geofence)
          console.log(maxBoundCordinates)        })
        setOrderDetails(data);
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  }, [orderID]);

  // Check if feedback already exists in DB
  useEffect(() => {
    const checkFeedback = async () => {
      try {
        const response = await getFeedback(orderID);
        // If feedback exists in DB, don't show the form
        if (response?.data?.data && response.data.data.feedback) {
          setHasFeedback(true);
        } else {
          setHasFeedback(false);
        }
      } catch (error) {
        // If API call fails or returns 404, assume no feedback exists
        // Show the feedback form
        setHasFeedback(false);
      } finally {
        setIsCheckingFeedback(false);
      }
    };
    
    if (orderID) {
      checkFeedback();
    }
  }, [orderID]);

  const handleFeedbackSubmitted = (feedbackData) => {
    setHasFeedback(true);
    setShowSuccessMessage(true);
    setSubmittedFeedback(feedbackData);
    // Hide success message after 5 seconds
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 5000);
  };
  useEffect (() => {
    const fetchFleetConfig = async () => {
      try {
        const response = await getFleetConfigByFleetId(process.env.REACT_APP_FLEETID);
        const data = response?.data?.data
        localStorage.setItem("fleetConfig", JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchFleetConfig();
  },[orderID])

  const formattedDate = (date) => {
    const orderDate = new Date(date);
    const yyyy = orderDate.getFullYear();
    let mm = orderDate.getMonth() + 1; // Months start at 0!
    let dd = orderDate.getDate();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return mm + "-" + dd + "-" + yyyy;
  };

  const pinRequired = expectedPin != null && expectedPin !== "";
  const showContent = !pinRequired || pinVerified;

  return (
    <>
      <PinVerificationModal
        open={pinRequired && !pinVerified}
        expectedPin={expectedPin}
        onVerified={() => setPinVerified(true)}
      />
      {showContent && (
      <div className="w-full mx-auto flex flex-col border-t-0 h-screen" style={{ maxWidth: "840px", margin: "0 auto", width: "100%" }}>
        <div style={{ height: "3rem", position: "relative", zIndex: 10 }}>
          <Header />
        </div>
        <div className="overflow-auto h-[calc(100vh-11rem)]">
          <div 
            className="bg-primary text-white text-center"
            style={{ 
              height: "auto", 
              minHeight: "120px", 
              padding: "16px 12px",
              paddingTop: "40px",
              paddingBottom: "20px"
            }}
          >
            <h3 style={{ fontSize: "20px", paddingTop: "8px", marginBottom: "8px" }}>
              {" "}
              Your Order was delivered.
              {!!Number(process.env.REACT_APP_FOODDELIVERY)&&
              (<span><br />Enjoy your meal!</span>)
              }
            </h3>
            {/* Order ID and Date in single line - white text */}
            <div style={{ display: "flex", justifyContent: "center", gap: "24px", marginTop: "8px", flexWrap: "wrap", color: "white", fontSize: "14px" }}>
              <div style={{ margin: 0 }}>
                <span style={{ marginRight: "8px" }}>Order ID:</span>
                <span> {orderID}</span>
              </div>
              <div style={{ margin: 0 }}>
                <span style={{ marginRight: "8px" }}>Date:</span>
                {orderDetails ? (
                  <span>{formattedDate(orderDetails?.createdAt)}</span>
                ) : (
                  <div style={loaderContainerStyle}>
                    <style>{keyframesAnimation}</style>
                    <div style={loaderStyle}></div>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          {/* Show success message after feedback submission */}
          {showSuccessMessage && (
            <div className="px-4 pb-4" style={{ marginTop: "12px" }}>
              <div className="bg-green-50 border-2 border-green-500 rounded-lg p-4 text-center">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <svg
                    className="w-6 h-6 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <h4 className="text-lg font-bold text-green-800">
                    Feedback Submitted Successfully!
                  </h4>
                </div>
                <p className="text-sm text-green-700">
                  Thank you for your feedback. We appreciate your input!
                </p>
              </div>
            </div>
          )}

          {/* Show submitted feedback */}
          {submittedFeedback && (
            <div className="px-4 pb-4" style={{ marginTop: "12px", paddingBottom: "80px" }}>
              <div className="mt-6 p-4 bg-white border border-[#E6E6E6] rounded-lg" style={{ maxWidth: "840px", width: "100%" }}>
                <h3 className="text-lg font-bold mb-4">Your Feedback</h3>
                
                {/* Rating Display */}
                <div className="mb-4">
                  <label className="block text-sm font-semibold mb-2">
                    Your Rating
                  </label>
                  <div className="flex gap-1 items-center justify-center">
                    {[1, 2, 3, 4, 5].map((star) => (
                      star <= submittedFeedback.rating ? (
                        <Star
                          key={star}
                          style={{
                            color: "#FFD700",
                            fontSize: "32px",
                          }}
                        />
                      ) : (
                        <StarBorder
                          key={star}
                          style={{
                            color: "#D3D3D3",
                            fontSize: "32px",
                          }}
                        />
                      )
                    ))}
                    <span className="ml-2 text-sm text-gray-600">
                      ({submittedFeedback.rating} out of 5 stars)
                    </span>
                  </div>
                </div>

                {/* Comment Display */}
                {submittedFeedback.comment && (
                  <div className="mb-4">
                    <label className="block text-sm font-semibold mb-2">
                      Your Comment
                    </label>
                    <div className="w-full p-3 bg-gray-50 border border-[#E6E6E6] rounded-lg">
                      <p className="text-sm text-gray-700 whitespace-pre-wrap">
                        {submittedFeedback.comment}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          
          {/* Show feedback form */}
          {!isCheckingFeedback && !hasFeedback && !submittedFeedback && orderDetails && (
            <div className="px-4 pb-4" style={{ marginTop: "12px", paddingBottom: "80px" }}>
              <CustomerFeedback
                orderDetails={orderDetails}
                orderID={orderID}
                onFeedbackSubmitted={handleFeedbackSubmitted}
              />
            </div>
          )}
        </div>
      </div>
      )}
      {showContent && <Footer orderdelivered={true} />}
    </>
  );
}

export default OrderDelivered;
